<template>
  <v-container fluid class="px-sm-10">
    <base-items class="d-none" store-module="itemgroups" @items="itemGroups = $event" @state="itemGroupsState = $event" />
    <base-items class="d-none" store-module="sideorders" @items="items = $event" @state="state = $event" />

    <v-card :loading="state.loading" class="mt-4 mx-3">
      <v-card-title>
        <v-row align="center">
          <v-col cols="auto" class="headline">Sideorders</v-col>
          <v-col>
            <v-btn color="primary" fab depressed small @click="openItemForm(createNewItem())" :disabled="(!itemGroups || itemGroups.length == 0) && !itemGroupsState.working"><v-icon>mdi-plus</v-icon></v-btn>
          </v-col>
        </v-row>
      </v-card-title>

      <v-card-text v-if="(!itemGroups || itemGroups.length == 0) && !itemGroupsState.working">
        <div class="body-1 mt-1 mb-4 ">
          <v-alert
            outlined
            type="info"
            color="secondary darken-1"
            border="left"
            width="auto"
          >
            <span>Create at least one item group before you create a side order.</span><br />
            <span>You find item groups in the menu on the left.</span>
          </v-alert>
        </div>
      </v-card-text>
      
      <v-card-text>
        <div v-if="!sortedItems || sortedItems.length == 0" class="">
          No side orders
        </div>
        <v-data-table
          v-else
          :headers="tableHeaders"
          :items="sortedItems"
          :items-per-page="-1"
          class="sideorders-table"
          must-sort
          sort-by="name"
          @click:row="openItemForm"
          >
          <template v-slot:item.price="{ item }">
            <span>{{ item.price }}:-</span>
          </template>
          <template v-slot:item.hidden="{ item }">
            <span>{{ item.hidden ? 'Hidden' : '' }}</span>
          </template>
          <template v-slot:item.id="{ item }">
            <span><v-btn text icon @click.stop="deleteItem(item)"><v-icon>mdi-delete</v-icon></v-btn></span>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog :value="!!editingItem" @input="closeItemForm()" max-width="600px" persistent>
      <side-order-form ref="itemForm" :item="editingItem" :item-groups="itemGroups" @submit="saveItem" @cancel="closeItemForm"/>
    </v-dialog>
    <ProductOptions class="mt-4"></ProductOptions>
  </v-container>
</template>

<script>
import {BaseItems} from 'dync-baseitem';
import {getItemById} from '@dynapp/wc-api-generic';
import SideOrderForm from '../components/SideOrderForm.vue';
import ProductOptions from '../components/ProductOptions.vue';
export default {
  props: [],
  data () {
    return {
      items: [],
      state: {},
      editingItem: null,
      removingItem: null,
      itemGroups: [],
      itemGroupsState: {},
      tableHeaders: [
        {
          text: 'Name',
          value: 'name'
        },
        {
          text: 'Price',
          value: 'price'
        },
        {
          text: 'Item group',
          value: 'itemgroupText'
        },
        {
          text: 'Hidden',
          value: 'hidden'
        },
        {
          text: 'Remove',
          value: 'id',
          sortable: false
        }
      ]
    }
  },
  computed: {
    sortedItems () {
      var _items = this.items.slice(0);
      _items = _items.map((item) => {
        item = Object.assign({}, item);
        item.itemgroupText = this.getItemGroupText(item.itemgroup);
        return item;
      });
      return _items.slice(0).sort((a, b) => {
        if (a.name > b.name) {
          return 1;
        } else if (a.name < b.name) {
          return -1;
        } else {
          return 0;
        }
      });
    }
  },
  methods: {
    createNewItem () {
      return {
        name: null,
        price: null,
        itemgroup: null
      };
    },
    openItemForm (item) {
      var _item = this.getItemById(item.id) || item;
      this.editingItem = _item;
    },
    closeItemForm () {
      this.editingItem = null;
      this.$refs.itemForm.reset();
    },
    saveItem (item) {
      var result;

      if (item.id)
        result = this.$store.dispatch('sideorders/updateItem', item);
      else
        result = this.$store.dispatch('sideorders/createItem', item);

      result.then(() => {
        this.closeItemForm();
        this.$snackbar({message: 'Side order saved', theme: 'success'});
      });
    },
    deleteItem (item) {
      this.$confirm({
        title: `Are you sure you want to delete side order "${item.name}"?`,
        message: 'You cannot undo this action'
      }).then(() => {
        this.removingItem = item.id;
        this.$store.dispatch('sideorders/deleteItem', item.id).then(() => {
          this.removingItem = null;
          this.$snackbar({message: 'Side order deleted', theme: 'success'});
          this.$store.dispatch('products/fetchItems');
        });
      });
    },
    getItemGroupText (id) {
      var itemGroup = this.getItemGroupById(id);
      var itemgroupText = '';
      if (itemGroup) {
        itemgroupText = itemGroup.name + '  (Vat ' + itemGroup.vat + '%)';
      } else if (!this.itemGroupsState.loading) {
        itemgroupText = 'MISSING ITEM GROUP';
      }
      return itemgroupText;
    },
    getItemGroupById (id) {
      return getItemById(this.itemGroups, id);
    },
    getItemById (id) {
      return getItemById(this.items, id);
    }
  },
  components: {
    BaseItems,
    SideOrderForm,
    ProductOptions
  }
}
</script>

<style lang="scss" scoped>
.sideorders-table:deep tbody tr {
  cursor: pointer;
}

.sideorders-table:deep td:last-of-type,
.sideorders-table:deep th:last-of-type {
    width: 100px;
    text-align: center !important;
}
</style>
